// extracted by mini-css-extract-plugin
export default {"thumbs":"rangeSlider_thumbs__2VCnH","label":"rangeSlider_label__w8t3P"};